// extracted by mini-css-extract-plugin
export default {"container":"VR2FXo71C1dCJsI6QwAH"};